/**
 * 組織を扱うモデル。
 * @module app/model/EarthQuake
 */
define([
    'idis/store/CacheStoreModel',
    'idis/store/CacheTreeRest'
], function(CacheStoreModel, CacheTreeRest) {
    /**
     * シングルトンを返す。
     */
    return new CacheStoreModel({
        store: new CacheTreeRest({
            target: '/api/earthquakes/earthQuake4Tree'
        })
    });
});
